<IziLayout :loading="loading">
  <router-view />
</IziLayout>